import type { SxProps, Theme } from '@mui/material/styles';

type TransferQueueStyleMap = {
    root: SxProps<Theme>
    header: SxProps<Theme>
    tableContainer: SxProps<Theme>
    tableHeaderRow: SxProps<Theme>
    tableHeaderCell: SxProps<Theme>
    loadingCell: SxProps<Theme>
    clickableRow: SxProps<Theme>
    userCellRow: SxProps<Theme>
    emptyCell: SxProps<Theme>
};

export const transferQueueStyles: TransferQueueStyleMap = {
    root: { display: 'flex', flexDirection: 'column', gap: 3 },
    header: { display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { sm: 'flex-start' }, gap: 2 },
    tableContainer: { border: '1px solid', borderColor: 'divider', borderRadius: 2 },
    tableHeaderRow: { bgcolor: 'grey.50' },
    tableHeaderCell: { fontWeight: 600 },
    loadingCell: { py: 5 },
    clickableRow: { cursor: 'pointer' },
    userCellRow: { display: 'flex', alignItems: 'center', gap: 1 },
    emptyCell: { py: 5, color: 'text.secondary' },
};
